import { z } from "zod";

export const RecommendedProductSchema = z.object({
  site: z.string().optional(),
  productId: z.string(),
  productTitle: z.string(),
  tags: z.string().array().default([]),
  minPrice: z.number().optional(),
  bodyHtml: z.string().optional().default(""),
  images: z.string().array(),
  handle: z.string(),
  score: z.number().optional(),
});

export const RecommendedProductRequestSchema = z.object({
  productId: z.string(),
  productTitle: z.string(),
});

export type RecommendedProductType = z.infer<typeof RecommendedProductSchema>;

export type RecommendedProductRequestType = z.infer<
  typeof RecommendedProductRequestSchema
>;

export const OpenAiSystemsList = ["contentTest", "textSuggestion"] as const;
export type OpenAiSystemType = (typeof OpenAiSystemsList)[number];

export const ScreenshotRecommendationSchema = z.object({
  order: z.number(),
  recommendation: z.string(),
  title: z.string(),
});

export type ScreenshotRecommendationType = z.infer<
  typeof ScreenshotRecommendationSchema
>;
